<template>
  <div>
    <page-header-wrapper>
      <div>
        <Detail ref="Detail" @back="isDetail = false"></Detail>
      </div>
      <a-card :bordered="false">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" labelAlign="right">
            <a-row :gutter="48">
              <a-col :md="6" :sm="24">
                <a-form-item label="经销商">
                  <a-input v-model="queryParam.dealerName" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="经销商电话">
                  <a-input
                    @keyup.enter="handleQuery"
                    v-model="queryParam.dealerPhone"
                    placeholder="请输入"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="经销商联系人">
                  <a-input
                    @keyup.enter="handleQuery"
                    v-model="queryParam.dealerUserName"
                    placeholder="请输入"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="分销商">
                  <a-input
                    @keyup.enter="handleQuery"
                    v-model="queryParam.distributorName"
                    placeholder="请输入"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="分销商电话">
                  <a-input
                    @keyup.enter="handleQuery"
                    v-model="queryParam.distributorPhone"
                    placeholder="请输入"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="分销商联系人">
                  <a-input
                    @keyup.enter="handleQuery"
                    v-model="queryParam.distributorUserName"
                    placeholder="请输入"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="水工">
                  <a-input
                    @keyup.enter="handleQuery"
                    v-model="queryParam.hydraulicName"
                    placeholder="请输入"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="水工电话">
                  <a-input
                    @keyup.enter="handleQuery"
                    v-model="queryParam.hydraulicPhone"
                    placeholder="请输入"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="旧系统编号">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.oldCode" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="订单号">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.orderNo" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="业主">
                  <a-input @keyup.enter="handleQuery" v-model="queryParam.ownerName" placeholder="请输入" allow-clear />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="业主电话">
                  <a-input
                    @keyup.enter="handleQuery"
                    v-model="queryParam.ownerPhone"
                    placeholder="请输入"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="验收员">
                  <a-input
                    @keyup.enter="handleQuery"
                    v-model="queryParam.pressureName"
                    placeholder="请输入"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" v-if="advanced">
                <a-form-item label="验收员电话">
                  <a-input
                    @keyup.enter="handleQuery"
                    v-model="queryParam.pressurePhone"
                    placeholder="请输入"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="(!advanced && 6) || 24" :sm="24">
                <span
                  class="table-page-search-submitButtons"
                  :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
                >
                  <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                  <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'" />
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>
        <!-- 增加修改 -->
        <!-- <create-form ref="createForm" :statusOptions="dict.type['sys_enable_disable']" @ok="getList" /> -->
        <!-- 审核 -->
        <!-- <Examine ref="Examine" @ok="getList"></Examine> -->
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :bordered="tableBordered"
        >
          <span slot="status" slot-scope="text, record">
            <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
          </span>
          <span slot="dealerName" slot-scope="text, record">
            <div>名称:{{ record.dealerName }}</div>
            <div>联系人:{{ record.dealerUserName }}</div>
            <div>电话:{{ record.dealerPhone }}</div>
          </span>
          <span slot="distributorName" slot-scope="text, record">
            <div>名称:{{ record.distributorName }}</div>
            <div>联系人:{{ record.distributorUserName }}</div>
            <div>电话:{{ record.distributorPhone }}</div>
          </span>
          <span slot="hydraulicName" slot-scope="text, record">
            <div>名称:{{ record.hydraulicName }}</div>
            <div>电话:{{ record.hydraulicPhone }}</div>
          </span>
              <span slot="ownerName" slot-scope="text, record">
            <div>名称:{{ record.ownerName }}</div>
            <div>电话:{{ record.ownerPhone }}</div>
          </span>
          <span slot="vrUrl" slot-scope="text, record">
            <div>
              {{ record.vrUrl }}
              <a-button v-if="record.vrUrl" type="link" @click="handleCopy(record.vrUrl)">复制</a-button>
            </div>
          </span>
          <span slot="pressureName" slot-scope="text, record">
            <div>名称:{{ record.pressureName }}</div>
            <div>电话:{{ record.pressurePhone }}</div>
          </span>
          <span slot="operation" slot-scope="text, record">
            <a-divider type="vertical" v-hasPermi="['abm-fix:order:edit']" v-if="record.status == 1" />
            <a @click="handleDetail(record)"> 详情 </a>
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="(total) => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </a-card>
    </page-header-wrapper>
  </div>
</template>
  <script>
import { orderPage } from '@/api/pressure/oldSystem'
import Detail from './detail'
import { tableMixin } from '@/store/table-mixin'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'Post',
  components: {
    Detail,
    //   Examine,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    firmId: {
      type: [String, Number],
    },
    regionId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      value: [],
      isDetail: false,
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
        regionId: undefined,
        orderType: undefined,
      },
      columns: [
        {
          title: '订单号',
          dataIndex: 'orderNo',
          width: '10%',
          align: 'center',
        },
        {
          title: '经销商',
          dataIndex: 'dealerName',
          scopedSlots: { customRender: 'dealerName' },
          align: 'center',
         width: '12%',
          visible: false,
        },
        {
          title: '分销商',
          dataIndex: 'distributorName',
          scopedSlots: { customRender: 'distributorName' },
          align: 'center',
         width: '12%',
          visible: false,
        },
        {
          title: '水工',
          dataIndex: 'hydraulicName',
         width: '10%',
          scopedSlots: { customRender: 'hydraulicName' },
          align: 'center',
          visible: false,
        },
           {
          title: '业主信息',
          dataIndex: 'ownerName',
         width: '10%',
          scopedSlots: { customRender: 'ownerName' },
          align: 'center',
          visible: false,
        },
        {
          title: '验收员',
          dataIndex: 'pressureName',
         width: '10%',
          scopedSlots: { customRender: 'pressureName' },
          align: 'center',
          visible: false,
        },
        {
          title: '预约时间',
          dataIndex: 'reservationTime',
          align: 'center',
          width: '7%',
          visible: false,
        },
        {
          title: 'VR地址',
          dataIndex: 'vrUrl',
          scopedSlots: { customRender: 'vrUrl' },
          align: 'center',
          width: '7%',
          visible: false,
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '7%',
          align: 'center',
        },
        {
          title: '审核时间',
          dataIndex: 'examineTime',
          width: '7%',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '4%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      orderType: 0,
      status: 1,
      agentList: [],
      listRegion: [],
    }
  },
  filters: {},
  created() {
      //  const tenantId = this.userTentant.tenantId
    // if (tenantId == '510082352907792384') {
    //   this.queryParam.tenantId = 1
    // } else if (tenantId == '552862209223647232') {
    //   this.queryParam.tenantId = 2
    // } else {
    //   this.queryParam.tenantId = tenantId
    // }
    this.getList()
  },
  computed: {
    ...mapGetters(['nickname', 'infoUser', 'userTentant']),
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    // 点击跳转详情
    handleDetail(e) {
      // this.isDetail = true
      this.$nextTick(() => {
        this.$refs.Detail.init(e)
      })
    },
    // 复制
    handleCopy(scope) {
      console.log()
      const save = function (e) {
        e.clipboardData.setData('text/plain', scope)
        e.preventDefault() // 阻止默认行为
      }
      document.addEventListener('copy', save) // 添加一个copy事件
      document.execCommand('copy') // 执行copy方法
      // 复制成功提示
      this.$message.success('复制成功')
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
      this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
    },

    /** 查询部门列表 */
    getList() {
      this.loading = true
      orderPage(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 下载验收报告
    handleLookDown(e) {
      acceptanceReport({ id: e.id }).then((res) => {
        // console.log(res,'resresres');
        // this.$message.success('下载成功')
        window.open(this.$url + res.data)
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
        regionId: undefined,
        orderType: undefined,
      }
      if (this.orderType) {
        this.queryParam.orderType = this.orderType
      } else {
        this.queryParam.status = this.status
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 禁用启用
    handleDeletes(row) {
      var that = this
      // let ids = []
      // if (row.id) {
      //   ids = [row.id]
      // } else {
      //   ids = this.ids
      // }
      const text = '是否要作废此订单?'
      this.$confirm({
        title: text,
        onOk() {
          return statusObj({ id: row.id }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否要作废此订单?',
        onOk() {
          return orderVoid({ id: row.id }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'fix/order/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>  